import { useState } from 'react';
import { Box, Text, Button, Flex, Heading, Icon } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Person, Team } from '@vibe/icons';
import { ItemPicker } from '../shared/components/ItemPicker';

type ChangePreviewClientModalProps = {
  isOpen: boolean;
  boardId: number;
  value: number | null;
  onClose: () => void;
  onSave: (clientItemId: number) => void;
};

export function ChangePreviewClientModal({ isOpen, boardId, value, onClose, onSave }: ChangePreviewClientModalProps) {
  const [selected, setSelected] = useState<number | null>(value);

  return (
    <AppModal
      show={isOpen}
      onClose={() => {
        onClose();
      }}
      contentSpacing={false}
      alertDialog={false}
      width={300}
    >
      <AppModalContent>
        <Flex gap={8} align="center" style={{ marginBottom: '24px' }}>
          <Icon icon={Person} size={22} style={{ transform: 'translate3d(0, -2px, 0)' }} />
          <Heading type="h3" weight="bold" align="start">
            Change preview client
          </Heading>
        </Flex>
        <Flex gap={16} direction="row" style={{ width: '100%' }}>
          <div style={{ flex: 1 }}>
            <ItemPicker boardId={boardId} value={selected ?? undefined} onChange={setSelected} placeholder="Choose a client" />
          </div>
          <Box>
            <Button
              size="medium"
              kind="primary"
              disabled={selected == null}
              onClick={() => {
                if (selected != null) {
                  onSave(selected);
                  onClose();
                }
              }}
            >
              Set
            </Button>
          </Box>
        </Flex>
        <Text
          type="text3"
          weight="normal"
          align="start"
          color="secondary"
          ellipsis={false}
          style={{ marginTop: '16px', marginBottom: '4px' }}
        >
          Choose the client whose data the preview should show.
        </Text>
      </AppModalContent>
    </AppModal>
  );
}
